import type { Components, Theme } from "@mui/material";

export const linkTheme: Components<Theme>["MuiLink"] = {
  defaultProps: {
    underline: "hover",
    color: "secondary",
  },
  styleOverrides: {
    underlineHover: {
      "&:hover": {
        textDecoration: "none",
      },
    },
  },
};
